import { createContext, useContext } from 'react';

const DataControlsContext = createContext<{
  compoundKeys: string[];
}>({ compoundKeys: [] });

export const useDataControls = () => useContext(DataControlsContext);
